import { Component, inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { first } from 'rxjs/operators';
import { ParametersService } from '../parameters/parameters.service';

@Component({
    selector: 'app-haytool-assist',
    templateUrl: './haytool-assist.component.html',
    styleUrls: ['./haytool-assist.component.css'],
    standalone: false
})
export class HaytoolAssistComponent implements OnInit {

    haytoolassist: SafeResourceUrl = '';

    public readonly parametersService = inject(ParametersService);
    private readonly sanitizer = inject(DomSanitizer);

    ngOnInit(): void {
        this.parametersService.getParametersObservable().pipe(first(params => !!params.country?.code)).subscribe(params => {
            const locale = params.country.code.split('_');
            const lang = locale[0];
            const land = locale[1];
            this.haytoolassist = this.sanitizer.bypassSecurityTrustResourceUrl(
                'https://www.poettinger.at/haytool-assist'
                + '?lang=' + lang
                + '&land=' + land
                + '&embedded=true'
            );
        });
    }

}
